export const fieldTranslations: Record<string, string> = {
  strategy_from_id: "Stratégie (depuis)",
  strategy_to_id: "Stratégie (vers)",
  quantity: "Quantité",
  date: "Date",
  weight: "Poids",
  market_value_local_ccy: "Valeur marché (devise locale)",
  market_value_ptf_ccy: "Valeur marché (devise ptf)",
  unit_price: "Prix unitaire",
  au_pair: "Au pair",
  percent_unit_price: "% prix unitaire",
  acquisition_cost: "Coût d'acquisition",
  premium_discount: "Prime/décote",
  impairment_losses: "Pertes de valeur",
  accrued_interests: "Intérêts courus",
  net_book_value: "Valeur nette comptable",
  tax_basis_value: "Valeur fiscale",
  pledged_asset: "Actif nanti",
  cic_code: "Code CIC",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
